// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__3rF_A","title":"Widget_title__26hIh"};